/**
 * Storefront analytics instrumentation — built and maintained by eLLMo AI.
 * https://www.tryellmo.ai/?utm_source=moosstudio&utm_medium=source_credit&utm_campaign=instrumentation_library
 */
!function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="Oo Lo $o init rl nl tl el ll pa il hl Ko capture sl Ao gl calculateEventProperties pl register register_once register_for_session unregister unregister_for_session Xo ml getFeatureFlag getFeatureFlagPayload getFeatureFlagResult getAllFeatureFlags isFeatureEnabled reloadFeatureFlags updateFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey displaySurvey cancelPendingSurvey canRenderSurvey canRenderSurveyAsync wl identify setPersonProperties unsetPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset kl shutdown setIdentity clearIdentity get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException addExceptionStep captureLog startExceptionAutocapture stopExceptionAutocapture loadToolbar get_property getSessionProperty yl cl createPersonProfile setInternalOrTestUser bl Do No opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing get_explicit_consent_status is_capturing clear_opt_in_out_capturing dl debug ma kn getPageViewId captureTraceFeedback captureTraceMetric Go".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
posthog.init('phc_wDAvnY5dG5deqWN8HeeGxNsDxANTjQaFZq46JJsXMwsz', {
    api_host: 'https://us.i.posthog.com',
    defaults: '2026-05-30',
    person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
});

(function () {
  'use strict';

  if (!window.posthog || typeof posthog.capture !== 'function') return;

  var PRODUCT_SUPER_KEYS = ['product_id', 'product_handle', 'product_title', 'product_vendor', 'product_type'];
  var LOGIN_PENDING_KEY = 'tryellmoai_analytics_login_pending';
  var SIGNUP_PENDING_KEY = 'tryellmoai_analytics_signup_pending';
  var analytics = window.themeAnalytics || {};
  var lastClickKey = '';
  var lastClickAt = 0;

  function snake(key) {
    return String(key)
      .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
      .replace(/-/g, '_')
      .toLowerCase();
  }

  function coerce(value) {
    if (value === undefined || value === null || value === '') return undefined;
    if (typeof value === 'number' && isNaN(value)) return undefined;
    if (typeof value !== 'string') return value;
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (/^-?\d+(\.\d+)?$/.test(value)) return Number(value);
    return value;
  }

  function compact(obj) {
    var out = {};
    if (!obj) return out;
    Object.keys(obj).forEach(function (key) {
      var value = obj[key];
      if (value === undefined || value === null || value === '') return;
      if (typeof value === 'number' && isNaN(value)) return;
      out[key] = value;
    });
    return out;
  }

  function flatten(obj, prefix) {
    var out = {};
    if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return out;
    Object.keys(obj).forEach(function (key) {
      var value = obj[key];
      if (value && typeof value === 'object') return;
      var dest = prefix ? prefix + '_' + snake(key) : snake(key);
      out[dest] = value;
    });
    return compact(out);
  }

  // The data-* attribute names (see snippets/product-analytics-attributes.liquid) are written to
  // already match the product_*/variant_* naming flatten() produces from analytics.product for
  // the same facts — e.g. data-variant-price, not data-price — so this is a plain spread with no
  // per-field rename table to keep in sync as attributes are added.
  function datasetProps(el) {
    var node = el && el.closest && el.closest('[data-product-id]');
    if (!node || !node.dataset) return {};
    var out = {};
    Object.keys(node.dataset).forEach(function (key) {
      out[snake(key)] = coerce(node.dataset[key]);
    });
    return compact(out);
  }

  function storageGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (error) {
      /* ignore */
    }
  }

  function storageRemove(key) {
    try {
      sessionStorage.removeItem(key);
    } catch (error) {
      /* ignore */
    }
  }

  function optionProperties(product, variant) {
    var props = {};
    if (!variant) return props;
    var options = (product && product.options) || [];
    options.forEach(function (name, index) {
      if (!name) return;
      var value = variant['option' + (index + 1)];
      if (value == null && variant.options) value = variant.options[index];
      if (value == null || value === '') return;
      var key = String(name).toLowerCase();
      if (key.indexOf('size') !== -1) props.option_size = value;
      else if (key.indexOf('color') !== -1 || key.indexOf('colour') !== -1) props.option_color = value;
      else props['option_' + key.replace(/\s+/g, '_')] = value;
    });
    return props;
  }

  function productProps(product, variant, extra) {
    var base = product || {};
    var nested = base.variant;
    var options = base.options;
    var rest = Object.assign({}, base);
    delete rest.variant;
    delete rest.options;
    var chosen = variant || nested || {};
    return compact({
      ...flatten(rest, 'product'),
      ...flatten(chosen, 'variant'),
      ...flatten(analytics.collection, 'collection'),
      ...optionProperties({ options: options }, chosen),
      currency: analytics.currency,
      ...extra,
    });
  }

  function productFromPage(extra) {
    return productProps(analytics.product, null, extra);
  }

  function productFromEl(el, extra) {
    // datasetProps is a fallback: it's the only product identity available off-PDP (e.g. a
    // collection card or quick-buy modal for a product analytics.product doesn't describe), but
    // where analytics.product / a live event *does* describe the current product, that data is
    // fresher and must win — datasetProps reads static data-* attributes rendered once at page
    // load, which go stale the moment a variant is switched without a full page reload.
    return compact({
      ...datasetProps(el),
      ...productFromPage(),
      source: sourceFromEl(el),
      ...extra,
    });
  }

  function sourceFromEl(el) {
    if (el && el.closest) {
      if (el.closest('quick-buy-modal')) return 'quick_buy';
      if (el.closest('product-card, .horizontal-product-card')) return 'card';
      if (el.closest('#cart-drawer, cart-drawer, .cart-page')) return 'cart';
      var form = el.closest('form, product-form');
      var formId = (form && (form.id || form.getAttribute('id'))) || '';
      if (formId.indexOf('quick-buy') !== -1) return 'quick_buy';
      if (formId.indexOf('featured-product') !== -1) return 'featured';
    }
    if (analytics.pageType === 'product') return 'pdp';
    return undefined;
  }

  function capture(eventName, properties) {
    try {
      posthog.capture(eventName, compact({ ...properties }));
    } catch (error) {
      /* never throw into the storefront */
    }
  }

  // Wraps an event listener / bootstrap function so anything it does — DOM reads, property
  // building, not just the final posthog.capture() call — can never surface as an uncaught error
  // on the storefront. One bad click target or unexpected DOM shape should drop that single
  // analytics event, not throw in front of the customer or spam error monitoring.
  function safe(fn) {
    return function () {
      try {
        return fn.apply(this, arguments);
      } catch (error) {
        /* swallow: analytics must never break or visibly error on the storefront */
      }
    };
  }

  function registerContext() {
    var customer = analytics.customer || {};
    posthog.register(
      compact({
        ...flatten({
          pageType: analytics.pageType,
          template: analytics.template,
          locale: analytics.locale,
          country: analytics.country,
          market: analytics.market,
          currency: analytics.currency,
        }),
        ...flatten(analytics.cart, 'cart'),
        is_logged_in: !!customer.loggedIn,
        ...(customer.loggedIn && customer.id
          ? { customer_id: customer.id, orders_count: customer.ordersCount }
          : {}),
      })
    );

    if (!customer.loggedIn) {
      posthog.unregister('customer_id');
      posthog.unregister('orders_count');
    }

    PRODUCT_SUPER_KEYS.forEach(function (key) {
      posthog.unregister(key);
    });

    if (analytics.pageType === 'product' && analytics.product) {
      var product = Object.assign({}, analytics.product);
      delete product.variant;
      delete product.options;
      posthog.register(flatten(product, 'product'));
    }
  }

  function registerCart(cart) {
    if (!cart) return;
    posthog.register(
      compact({
        cart_item_count: cart.item_count != null ? cart.item_count : cart.itemCount,
        cart_total: cart.total_price != null ? cart.total_price : cart.total,
      })
    );
  }

  function syncIdentity() {
    var customer = analytics.customer || {};

    if (customer.loggedIn && customer.id) {
      posthog.identify(
        String(customer.id),
        compact({
          ...flatten(customer),
          shopify_customer_id: customer.id,
          is_logged_in: true,
        })
      );

      var loginPending = storageGet(LOGIN_PENDING_KEY);
      var signupPending = storageGet(SIGNUP_PENDING_KEY);
      if (loginPending) {
        capture('user_logged_in', { method: 'account' });
        storageRemove(LOGIN_PENDING_KEY);
      }
      if (signupPending) {
        capture('user_signup_completed', { method: 'account' });
        if (!loginPending) capture('user_logged_in', { method: 'signup' });
        storageRemove(SIGNUP_PENDING_KEY);
      }
      return;
    }

    posthog.register({ is_logged_in: false });
    posthog.unregister('customer_id');
    posthog.unregister('orders_count');

    // Reached the logged-out state after a form submit (e.g. a failed login/signup) set a
    // pending flag; it never became true, so drop it rather than letting it mis-attribute a
    // later, unrelated successful login on this device.
    storageRemove(LOGIN_PENDING_KEY);
    storageRemove(SIGNUP_PENDING_KEY);
  }

  function elementContext(el) {
    if (el.closest('#cart-drawer, cart-drawer, .cart-page')) return 'cart';
    if (el.closest('quick-buy-modal')) return 'quick_buy';
    if (el.closest('product-card, .horizontal-product-card')) return 'product_card';
    if (el.closest('header, .header, sticky-header')) return 'header';
    if (el.closest('.customer-account-box') || (analytics.pageType && String(analytics.pageType).indexOf('customers') === 0)) {
      return 'account';
    }
    if (el.closest('.product-info, product-form') || analytics.pageType === 'product') return 'pdp';
    return 'other';
  }

  function elementText(el) {
    var clone = el.cloneNode(true);
    var visuallyHidden = clone.querySelectorAll('.sr-only, [hidden]');
    for (var i = 0; i < visuallyHidden.length; i++) visuallyHidden[i].remove();
    return String(clone.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
  }

  function interactiveTarget(node) {
    if (!node || node.nodeType !== 1) return null;
    return node.closest('a, button, [role="button"], summary, input[type="submit"], label');
  }

  function isLoginForm(form) {
    var action = (form.getAttribute('action') || form.action || '').split('?')[0];
    return /\/account\/login\/?$/.test(action);
  }

  function isSignupForm(form) {
    if (isLoginForm(form)) return false;
    return !!(form.querySelector('[name="customer[first_name]"]') || form.querySelector('[name="customer[password_confirmation]"]'));
  }

  function bindClickInstrumentation() {
    document.addEventListener(
      'click',
      safe(function (event) {
        var node = event.target;
        if (node && node.nodeType !== 1) node = node.parentElement;
        var target = interactiveTarget(node);
        if (!target) return;
        if (target.closest('script, style, noscript')) return;

        var href = target.getAttribute('href') || (target.href && !String(target.href).startsWith('javascript:') ? target.href : undefined);
        // Distinguishes visually-identical controls that share tag/id/name/text — e.g. every
        // product card's icon-only quick-add button reduces to the same signature, since its
        // label is sr-only (stripped by elementText) and it has no id/name/href — by folding in
        // href (differs per link) and the nearest [data-product-id] (differs per card) so a rapid
        // double-tap across two different cards isn't dropped as a duplicate of the same click.
        var productIdForKey = (target.closest && target.closest('[data-product-id]') || {}).dataset;
        var now = Date.now();
        var clickKey =
          (target.tagName || '') + '|' + (target.id || '') + '|' + (target.getAttribute('name') || '') + '|' +
          (href || '') + '|' + (productIdForKey ? productIdForKey.productId || '' : '') + '|' + elementText(target);
        if (clickKey === lastClickKey && now - lastClickAt < 400) return;
        lastClickKey = clickKey;
        lastClickAt = now;

        var product = productFromEl(target);

        capture('element_clicked', {
          element_tag: target.tagName.toLowerCase(),
          element_id: target.id,
          element_name: target.getAttribute('name'),
          element_text: elementText(target),
          element_href: href,
          element_type: target.getAttribute('type'),
          element_context: elementContext(target),
          ...product,
        });

        if (target.getAttribute('data-tryellmoai-analytics') === 'logout' || (href && /\/account\/logout/.test(href))) {
          capture('user_logged_out');
          try {
            posthog.reset();
          } catch (error) {
            /* ignore */
          }
          return;
        }

        if (target.closest('.shopify-payment-button')) {
          capture('product_buy_now_clicked', { ...product, source: sourceFromEl(target) || 'pdp' });
        }

        if (target.getAttribute('name') === 'checkout' || target.closest('button[name="checkout"]')) {
          capture('checkout_started', {
            ...flatten(analytics.cart, 'cart'),
            currency: analytics.currency,
            source: sourceFromEl(target) || 'cart',
          });
        }

        if (target.closest('product-card a, .horizontal-product-card a') && !target.closest('product-form, quick-buy-modal, .product-card__quick-add-button')) {
          capture('product_card_clicked', { ...product, source: 'card' });
        }

        if (target.closest('.moos-sizechart summary, .sgm-Head')) {
          capture('size_guide_opened', productFromPage({ source: 'pdp' }));
        }

        if (target.closest('.moos-info-trigger summary')) {
          captureAccordion('accordion_opened', target, {
            accordion_open: true,
            open_method: 'drawer',
          });
        }
      }),
      true
    );
  }

  function bindAuthForms() {
    document.addEventListener(
      'submit',
      safe(function (event) {
        var form = event.target;
        if (!form || form.tagName !== 'FORM') return;
        if (isLoginForm(form)) {
          storageSet(LOGIN_PENDING_KEY, '1');
          capture('user_login_submitted', { method: 'account' });
        } else if (isSignupForm(form)) {
          storageSet(SIGNUP_PENDING_KEY, '1');
          capture('user_signup_submitted', { method: 'account' });
        }
      }),
      true
    );
  }

  function accordionTitleFrom(el) {
    if (!el) return undefined;
    var summary = el.tagName === 'SUMMARY' ? el : el.querySelector && el.querySelector('summary');
    if (!summary && el.closest) summary = el.closest('summary');
    return summary ? elementText(summary) : undefined;
  }

  function accordionSource(el) {
    if (!el || !el.closest) return 'pdp';
    if (el.closest('#moos-sizechart-drawer, .moos-sizechart-drawer, .moos-sizechart')) return 'size_chart';
    if (el.closest('#moos-info-drawer, .moos-info-drawer')) return 'info_drawer';
    return 'pdp';
  }

  function captureAccordion(eventName, el, extra) {
    capture(eventName, compact({
      ...productFromPage(),
      accordion_title: accordionTitleFrom(el),
      source: accordionSource(el),
      ...extra,
    }));
  }

  function bindAccordionInstrumentation() {
    document.addEventListener(
      'toggle',
      safe(function (event) {
        var details = event.target;
        if (!details || details.tagName !== 'DETAILS') return;
        if (!details.closest('.accordion, accordion-disclosure')) return;
        if (details.closest('.moos-info-trigger') && !details.closest('x-drawer, .drawer')) return;

        captureAccordion(details.open ? 'accordion_opened' : 'accordion_closed', details, {
          accordion_open: !!details.open,
          open_method: 'toggle',
        });
      }),
      true
    );
  }

  function bindThemeInstrumentation() {
    document.addEventListener('variant:change', safe(function (event) {
      var variant = event.detail && event.detail.variant;
      var previous = event.detail && event.detail.previousVariant;
      if (variant && previous && variant.id === previous.id) return;
      capture('product_variant_selected', {
        // datasetProps first: it's the fallback identity for the quick-buy-modal case (a
        // different product than analytics.product, off the PDP); the live `variant` from this
        // event must win over it for anything datasetProps also reports (variant_id/variant_price),
        // since datasetProps reflects the page-load variant, not the one just selected.
        ...datasetProps(event.target),
        ...productProps(analytics.product, variant, {
          source: sourceFromEl(event.target) || 'pdp',
          previous_variant_id: previous && previous.id,
        }),
      });
    }));

    document.addEventListener('variant:add', safe(function (event) {
      var item = ((event.detail && event.detail.items) || [])[0] || {};
      var source = sourceFromEl(event.target) || 'pdp';
      capture('product_added_to_cart', {
        // The /cart/add.js line item uses Shopify's own field names (price, sku, vendor, handle,
        // plus a bare `id` that's really the variant id), which don't match our product_*/
        // variant_* convention — spread it first as raw extra context, then let productFromEl()
        // (already in that convention, and — per the ordering fix above — backed by the live
        // variant/dataset) win on any overlapping key, so this event can't end up with a wrong
        // value under the *correctly* named property.
        ...flatten(item),
        ...productFromEl(event.target),
        quantity: item.quantity,
        source: source,
      });
      if (event.detail && event.detail.cart) registerCart(event.detail.cart);
    }));

    document.addEventListener('cart:error', safe(function (event) {
      capture('product_add_to_cart_failed', {
        ...productFromEl(event.target),
        error: event.detail && event.detail.error,
      });
    }));

    document.addEventListener('cart:change', safe(function (event) {
      var detail = event.detail || {};
      if (detail.cart) registerCart(detail.cart);
      if (detail.baseEvent === 'variant:add') return;
      capture('cart_updated', {
        ...flatten(detail.cart, 'cart'),
        cart_item_count: detail.cart && detail.cart.item_count,
        cart_total: detail.cart && detail.cart.total_price,
        currency: analytics.currency,
        base_event: detail.baseEvent,
      });
    }));

    // theme.js dispatches dialog:after-show/after-hide as plain `new CustomEvent(...)`, i.e.
    // bubbles: false. A document-level listener only ever sees a non-bubbling event during the
    // capture (trickle-down) phase — that phase happens regardless of the bubbles flag, only the
    // bubble phase depends on it — so these need { capture: true }, same as the `toggle` listener
    // above. Without it, cart_viewed/product_quick_buy_opened/accordion_closed silently never fire.
    document.addEventListener(
      'dialog:after-show',
      safe(function (event) {
        var target = event.target;
        if (!target || !target.matches) return;
        if (target.matches('#cart-drawer, cart-drawer')) {
          capture('cart_viewed', {
            ...flatten(analytics.cart, 'cart'),
            currency: analytics.currency,
            source: 'drawer',
          });
        }
        if (target.matches('quick-buy-modal')) {
          capture('product_quick_buy_opened', productFromEl(target, { source: 'quick_buy' }));
        }
      }),
      true
    );

    document.addEventListener(
      'dialog:after-hide',
      safe(function (event) {
        var target = event.target;
        if (!target || !target.matches) return;
        if (!target.matches('#moos-info-drawer, #moos-sizechart-drawer, .moos-info-drawer, .moos-sizechart-drawer')) return;
        var openDetails = target.querySelector('details[open]') || target;
        captureAccordion('accordion_closed', openDetails, {
          accordion_open: false,
          open_method: 'drawer',
        });
      }),
      true
    );
  }

  function capturePageViews() {
    if (analytics.pageType === 'product' && analytics.product) {
      capture('product_viewed', productFromPage({ source: 'pdp' }));
    }
    if (analytics.pageType === 'cart') {
      capture('cart_viewed', {
        ...flatten(analytics.cart, 'cart'),
        currency: analytics.currency,
        source: 'page',
      });
    }
  }

  // Each bootstrap step runs independently: if one throws (unexpected analytics/DOM shape), the
  // rest still initialize — e.g. a broken registerContext() shouldn't also cost us click tracking.
  [
    registerContext,
    syncIdentity,
    bindClickInstrumentation,
    bindAuthForms,
    bindAccordionInstrumentation,
    bindThemeInstrumentation,
    capturePageViews,
  ].forEach(function (step) {
    safe(step)();
  });
})();
